import { render, staticRenderFns } from "./vertical.vue?vue&type=template&id=7c52e0c8&"
import script from "./vertical.vue?vue&type=script&lang=js&"
export * from "./vertical.vue?vue&type=script&lang=js&"
import style0 from "./vertical.vue?vue&type=style&index=0&id=7c52e0c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports